<div class="center-xy" [ngStyle]="{ overflow: zones.overflow ? 'auto' : 'hidden'}"
     *ngIf="zones.selectedZone">
    <div class="zone-control-wrapper bg-light" data-testid="opentherm-info">
        <div class="zone-control__top">
            <div class="zone-control__top-icon bg-style bg-style__icon border-light">
                <img ngSrc="/assets/img/zone_icons/light/opentherm-light.svg"
                    width="45" height="45" alt="" />
            </div>
            <p class="zone-control__top-name font-bold font-24 bg-style bg-style__label color-light">
                {{ subtitle(3645) }}
            </p>
        </div>

        <div class="zone-control__content">
            <div class="zone-control__buttons-top">
                <div class="zone-control__close-button cursor-pointer bg-cancel bg-cancel__button"
                    data-testid="back-button"
                    (click)="zones.goBack()">
                    <img ngSrc="/assets/img/zone_icons/back_without_border.svg"
                        width="40" height="40" alt="" />
                </div>
            </div>
            <div class="dropdown-list dropdown-list--info">
                <div class="dropdown-list__item color-basic font-12 font-bold"
                     *ngIf="zones.selectedZone.tile.params.modulationPercentage >= 0
                        && zones.selectedZone.tile.params.modulationPercentage <= 100">
                    <p class="dropdown-list__item-name">
                        {{ subtitle(428) }}
                    </p>
                    <div class="dropdown-list__value dropdown-list__value--single">
                        <p class="dropdown-list__value-name">
                            {{ zones.selectedZone.tile.params.modulationPercentage | format:8 }}
                        </p>
                    </div>
                </div>
                <div class="dropdown-list__item color-basic font-12 font-bold"
                    *ngIf="zones.selectedZone.tile.params.flags.communication === 0">
                    <p class="dropdown-list__item-name">
                        {{ subtitle(331) }}
                    </p>
                    <div class="dropdown-list__value dropdown-list__value--single">
                        <img class="dropdown-list__signal dropdown-list__signal--no-margin"
                             data-testid="parameter-communication-icon"
                             ngSrc="/assets/img/zone_icons/cable_black_48dp.svg"
                             width="19" height="19" alt="" />
                    </div>
                </div>

                <div class="dropdown-list__item color-basic font-12 font-bold">
                    <p class="dropdown-list__item-name">
                        {{ subtitle(342) }}
                    </p>
                    <div class="dropdown-list__value dropdown-list__value--single">
                        <p class="dropdown-list__value-name">
                            {{ zones.selectedZone.tile.params.flags.heatingCurve | format:28 }}
                        </p>
                    </div>
                </div>

                <div class="dropdown-list__item color-basic font-12 font-bold">
                    <p class="dropdown-list__item-name">
                        {{ subtitle(2585) }}
                    </p>
                    <div class="dropdown-list__value dropdown-list__value--single">
                        <p class="dropdown-list__value-name">
                            {{ zones.selectedZone.tile.params.flags.activeHeating | format:28 }}
                        </p>
                    </div>
                </div>

                <div class="dropdown-list__item color-basic font-12 font-bold">
                    <p class="dropdown-list__item-name">
                        {{ subtitle(2586) }}
                    </p>
                    <div class="dropdown-list__value dropdown-list__value--single">
                        <p class="dropdown-list__value-name">
                            {{ zones.selectedZone.tile.params.flags.activeDHW | format:28 }}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
